import { render, staticRenderFns } from "./ComponentWatchList.vue?vue&type=template&id=655fa4ad"
import script from "./ComponentWatchList.vue?vue&type=script&lang=js"
export * from "./ComponentWatchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports